import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useMatch } from 'react-router-dom';
import Collection from './pages/Collection';
import OrderOnline from './pages/OrderOnline';
import { useDispatch, useSelector } from 'react-redux';
import { historyMW } from '../../helpers/routingHelpers';
import { freshRelevance, gtmEvent } from '../../helpers/commonHelpers';
import { useClearBasketDeliveryMutation, useSetRestaurantDistanceMutation, useUpdateBasketDeliveryMutation, useClearBasketMutation } from '../../services/basket.api';
import { useLazyFindAddressQuery, useLazyGetAddressDetailsQuery, useLazyGetRestaurantByNameQuery, useLazyGetRestaurantLatLongQuery, useLazyGetRestaurantByLatLongForDeliveryQuery, useLazyFindAddressLatLongQuery } from '../../services/restaurant.api';
import { ChangeRestaurantModalWrapper, NotificationModalWrapper } from '../../helpers/modalHelpers';
import { setSessionSearchTerm, setSessionSearchResults, setSessionDeliveryAddress } from '../../store/sessionSlice';
import { postMessageWithAwait } from '../../helpers/appHelpers';
import { clearBundles, resetMenuState, setInitialMenuRender } from '../../store/menuSlice';
import { useConfig } from '../../helpers/useConfig';
import { isValidPostcode, extractPostcode } from '../../helpers/postcodeHelpers';


const HomeController = ({ showChangeRestaurantModal, setShowChangeRestaurantModal }) => {
  const collectionPage = useMatch('/collection');
  const deliveryPage = useMatch('/delivery');
  const config = useConfig();
  const { cmsConfig, inApp, restaurantId, searchTerm, isOriginalDeliveryJourney } = useSelector(state => state.session);
  const { numberOfItems } = useSelector(state => state.basket);
  const { delivery } = useSelector(state => state.basket);
  const [prospectiveRestuarant, setProspectiveRestaurant] = useState(null);
  const navigate = useNavigate();
  const [updateBasketDelivery] = useUpdateBasketDeliveryMutation();
  const [clearBasket] = useClearBasketMutation();
  const { searchResults } = useSelector(state => state?.session);
  const [showSearchError, setShowSearchError] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [clearBasketDelivery] = useClearBasketDeliveryMutation();
  const [getRestaurantByName, { data, isLoading: restaurantByNameLoading, isFetching: restaurantByNameFetching, isUninitialized, isError: restaurantByNameIsError }, { lastArg }] = useLazyGetRestaurantByNameQuery();
  const [findAddress] = useLazyFindAddressQuery();
  const [findAddressLatLong] = useLazyFindAddressLatLongQuery();
  const [getAddressDetailsQuery] = useLazyGetAddressDetailsQuery();
  const [getRestaurantsByLatLongForDelivery] = useLazyGetRestaurantByLatLongForDeliveryQuery();
  const [restaurantsObtainedForAddress, setRestaurantsObtainedForAddress] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addressClickFromDropdown, setAddressClickFromDropdown] = useState(false);
  const [getRestaurantByLocation, { isLoading: restaurantByLocationLoading, isFetching: restaurantByLatLongFetching }] = useLazyGetRestaurantLatLongQuery();
  const [setRestaurantDistance] = useSetRestaurantDistanceMutation();
  const [filteredBanners, setBanners] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hasUserTyped, setHasUserTyped] = useState(false);
  const location = useLocation();
  const setSearchTerm = (newSearchTerm) => {
    dispatch(setSessionSearchTerm(newSearchTerm));
  };
  const setSearchResults = (SearchResults) => {
    dispatch(setSessionSearchResults(SearchResults));
  };
  const setDeliveryAddress = (isDelivery) => {
    if (isDelivery) {
      dispatch(setSessionDeliveryAddress(null));
    }
  };
  const [deliveryAddressPublicId, setDeliveryAddressPublicId] = useState(null);
  const [deliveryPostCode, setDeliveryPostcode] = useState(null);

  const getAddressDetails = async (publicId) => {
    var result = await getAddressDetailsQuery({ publicId });
    return result;
  }

  const updateAddressSearch = async (newSearchTerm, publicId) => {
    var result = await getAddressDetails(publicId);
    // Extract postcode from user's search term if it's a valid postcode, otherwise use Woosmap's postcode as fallback
    const userEnteredPostcode = isValidPostcode(newSearchTerm) ? newSearchTerm : extractPostcode(newSearchTerm);
    if (userEnteredPostcode) {
      setDeliveryPostcode(userEnteredPostcode);
    } else if (result && result.data?.postCode) {
      setDeliveryPostcode(result.data.postCode);
    }

    if (result && result.data && result.data.results && result.data.results.length > 0) {
      setAddresses(result.data.results);
    } else if (result && result.data) {
      setLoading(true);
      setAddresses([]);
      const latitude = result.data.latitude;
      const longitude = result.data.longitude;
      var response = await getRestaurantsByLatLongForDelivery({ latitude, longitude, address: newSearchTerm });
      setRestaurantsObtainedForAddress(true);
      setLoading(false);
      if (response.isSuccess && response.data) {
        handleSearchResult(response.data, response.data.isDelivery, false, newSearchTerm);
        setDeliveryAddressPublicId(publicId);
      }
    } else {
      setAddresses([]);
    }
  }

  useEffect(() => {
    if (location?.search) {
      const queryParams = new URLSearchParams(location.search);
      const postcode = queryParams.get('postcode');
      if (!postcode) return;
      setSearchTerm(postcode);
    }
  }, []);

  const searchByText = async (isDelivery, searchTermOverride) => {
    setDeliveryAddress(isDelivery);
    searchTermOverride = searchTermOverride ? extractPostcode(searchTermOverride) : searchTermOverride;
    const term = searchTermOverride || searchTerm;
    if (!isDelivery && addresses?.length > 0) {
      setAddresses([]);
    }
    const trimmedTerm = term.trim();
    const isPostcodeValid = !isDelivery || isValidPostcode(trimmedTerm);

    if (!isOriginalDeliveryJourney || (trimmedTerm.length && isPostcodeValid)) {
      setLoading(true);
      if (delivery) {
        await clearBasketDelivery();
      }
      if (isDelivery && !isOriginalDeliveryJourney) {
        if (!term) {
          setLoading(false);
          setSearchResults({ error: 'Please enter a location' });
          setShowSearchError(true);
          return;
        }
        if (restaurantsObtainedForAddress) {
          setSearchResults(null);
          setRestaurantsObtainedForAddress(false);
        }
        var result = await findAddress({ query: term, isPostalCode: isPostcodeValid });
        if (result && result.data && result.data.results) {
          setAddresses(result.data.results);
        } else {
          setAddresses([]);
        }
        setLoading(false);
      }
      else {
        var result = await getRestaurantByName({ postCode: term, isDelivery }, false);
        if (result && result.data && result.data.restaurants) {
          handleSearchResult(result.data, result.data.isDelivery, false, term);
        }
      }
    } else {
      setSearchResults(isDelivery ? { error: 'Please enter a valid postcode' } : null);
      setShowSearchError(true);
    }
  };

  useEffect(() => {
    if (restaurantByNameIsError) {
      setLoading(false);
      setSearchResults({ error: 'Please enter a valid postcode' });
      setShowSearchError(true);
    }
  }, [restaurantByNameIsError])

  useEffect(() => {
    if (!searchTerm.length) {
      setSearchResults(null);
      setLoading(false);
    }
    let lowerPathName = location?.pathname?.toLowerCase() ?? '';
    if (
      !restaurantByNameFetching
      && !restaurantByNameLoading
      && !restaurantByLocationLoading
      && !isUninitialized
      && data?.postcode?.toLowerCase() === searchTerm?.toLowerCase()
      && ('isDelivery' in lastArg && location?.pathname !== '/' ? lastArg.isDelivery
        && lowerPathName.includes('delivery') || !lastArg.isDelivery && lowerPathName.includes('collection') : true)
    ) {
      setLoading(false);
      handleSearchResult(data, data.isDelivery, false);
    }
  }, [searchTerm, data, restaurantByNameFetching, restaurantByNameLoading, restaurantByLocationLoading, isUninitialized]);

  const searchByLatLong = async (isDelivery) => {
    setDeliveryAddress(isDelivery);
    setHasUserTyped(false);
    const success = async ({ coords: { latitude, longitude } }) => {
      setLoading(true);
      if (isOriginalDeliveryJourney) {
        const result = await getRestaurantByLocation({ latitude, longitude, isDelivery });
        handleSearchResult(result.data, isDelivery, true);
      }
      else {
        if (restaurantsObtainedForAddress) {
          setSearchResults(null);
          setRestaurantsObtainedForAddress(false);
        }
        var result = await findAddressLatLong({ latitude, longitude });
        if (result && result.data && result.data.results) {
          setAddresses(result.data.results);
        } else {
          setAddresses([]);
        }
      }
      setLoading(false);

    };
    const error = (error) => {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          setSearchResults({ error: 'Please grant access to location services if you wish to search by location.' });
          break;
        case error.POSITION_UNAVAILABLE:
          setSearchResults({ error: 'Location information is unavailable.' });
          break;
        case error.TIMEOUT:
          setSearchResults({ error: 'The request to get user location timed out.' });
          break;
        case error.UNKNOWN_ERROR:
          setSearchResults({ error: 'An unknown error occurred.' });
          break;
      }
      setShowSearchError(true);
      setLoading(false);
    };
    setLoading(true);
    if (inApp) {
      try {
        const result = await postMessageWithAwait({ type: 'GET_LOCATION' }, 'LATLONG');
        success({ coords: { latitude: result?.location?.latitude, longitude: result?.location?.longitude } });
      } catch (err) {
        setSearchResults({ error: 'Location information is unavailable. Please check your location permissions.' });
        setShowSearchError(true);
        setLoading(false);
      }
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  };

const handleSearchResult = async (result, isDelivery, latLongSearch, searchTermOverride) => {
    const params = {
      searchTerm: searchTermOverride ? searchTermOverride : searchTerm,
      searchResultsCount: result?.restaurants?.length ?? 0,
      searchDistanceToNearestRestaurant: result?.closestRestaurantDistance
    };
    gtmEvent(isDelivery ? 'Delivery Search' : 'Collection Search', params);
    if (!result || result.error) {
      gtmEvent('restaurant_search_error', params);
      setShowNotification({ heading: 'Oops!', description: 'Something went wrong, please try again.' });
      return;
    } else {
      setSearchResults(result);
      setSearchTerm(result.postcode);
      const isSuccessful = isDelivery ? result.canOrderDelivery : result.canOrderCollection;
      if (isSuccessful) {
        historyMW.push('', isDelivery, navigate, { restaurants: result.restaurants, searchTerm, postCode: searchTerm, showClosedSites: true });
      } else {
        const gaParams = {
          searchTerm: searchTerm,
          searchResultsCount: result?.restaurants?.length ?? 0,
          searchDistanceToNearestRestaurant: result?.closestRestaurantDistance
        }

        if (searchTerm.length > 3 && isValidPostcode(searchTerm))
          gaParams.searchTerm = searchTerm.trim().slice(0, searchTerm.length - 3)?.trim();  // Get the outward part of the postcode   

        if (result.restaurants && isDelivery) {
          const noRestaurantsAvailableCurrently = result.restaurants?.some(r => r.isDeliveryHidden) ?? false;
          if (noRestaurantsAvailableCurrently || !isDelivery)
            historyMW.push('', isDelivery, navigate, { restaurants: result.restaurants, searchTerm, postCode: searchTerm, showClosedSites: true });
          if (!noRestaurantsAvailableCurrently) {

            gtmEvent('restaurant_search_no_delivery', gaParams);
            setShowNotification({
              heading: 'We’re Sorry!',
              description: 'Unfortunately we are not currently delivering to this postcode. Why not try collection instead?',
              redirectFn: async () => {
                if (inApp) window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'SWITCH_JOURNEY_NAVBAR', journey: 'collection' }));
                setSearchTerm(result.postcode);
                searchByText(false, result.postcode);
                historyMW.push('', false, navigate);
              },
              redirectCta: 'Order for collection'
            });
          }
        } else if (!isDelivery && result.restaurants?.length) {
          if (result.restaurants.length) {
            historyMW.push('', isDelivery, navigate, { restaurants: result.restaurants, searchTerm, postCode: searchTerm });
          }
        } else {
          gtmEvent(latLongSearch ? 'restaurant_search_no_location' : 'restaurant_search_no_restaurant', params);
          setShowNotification({
            heading: 'We’re Sorry!',
            description: latLongSearch ? 'Sorry but we can\'t find your location. Please enter your postcode' : 'We have no restaurants within a 10 mile radius of your postcode.'
          });
        }
      }
    }
  };

  const handleContinue = async (restaurant, switchToCollection) => {
    const restaurantChanged = restaurant.id !== restaurantId;
    const haveItemsInBasket = numberOfItems > 0;

    if (restaurantChanged && haveItemsInBasket) {
      setShowChangeRestaurantModal(true);
    } else {
      handleRestaurantSelected(restaurant, switchToCollection);
    }
  };

  const handleRestaurantSelected = async (restaurant, switchToCollection) => {
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'CLEAR_BASKET' }));
    const isDelivery = !switchToCollection && !!restaurant.delivery;
    if (restaurant.id && restaurantId) {
      if (restaurant.id !== restaurantId) {
        dispatch(resetMenuState());
        if (isDelivery) {
          await clearBasketDelivery();
        }
        await clearBasket();
      }
    }

    if (isDelivery) {
      const delivery = {
        ...restaurant,
        ...restaurant.delivery,
        fractional: restaurant.delivery.delivery_fee.fractional,
        currencyCode: restaurant.delivery.delivery_fee.currency_code,
        lat: restaurant.delivery.location.lat,
        lon: restaurant.delivery.location.lon,
        userPostcode: isOriginalDeliveryJourney && isValidPostcode(searchTerm) ? searchTerm : deliveryPostCode,
        address: searchTerm,
        deliveryQuote: restaurant.delivery,
        deliveryAddressId: deliveryAddressPublicId,
        isOriginalSearch: isOriginalDeliveryJourney,
        deliveryJourney: 'old'
      };
      await updateBasketDelivery({ ...delivery, searchTerm, restaurantId: restaurant.id });
    } else {
      await setRestaurantDistance({ id: restaurant.id, distance: Math.round(restaurant.distance), searchTerm });
    }
    gtmEvent(isDelivery ? 'delivery_selected_restaurant' : 'collection_selected_restaurant');

    freshRelevance('pageChange', null, { 'sendBeacon': true });
    setTimeout(() => setSearchResults(false), 200);
    dispatch(setInitialMenuRender(true));
    historyMW.push(`/menu/${restaurant.id}`, isDelivery, navigate);
  };

  const goToDeliveryPage = () => {
    if (searchTerm?.length > 0)
      setLoading(true);
    historyMW.push('', true, navigate, { searchTerm, postCode: searchTerm, showClosedSites: true });
  };

  const searchProps = {
    searchTerm,
    setSearchTerm,
    searchResults,
    isLoading: loading,
    setSearchResults,
    showSearchError,
    setShowSearchError,
    showNotification,
    setShowNotification,
    searchByText,
    searchByLatLong,
    handleRestaurantSelected: handleContinue,
    hasUserTyped,
    setHasUserTyped,
    updateSearchTerm: (value) => {
      setHasUserTyped(true);
      setShowSearchError(false);
      setSearchTerm(value);
    },
    addresses,
    setSearchTermFromAddress: (value, publicId) => {
      setHasUserTyped(isOriginalDeliveryJourney ? true : false);
      setAddressClickFromDropdown(true);
      setShowSearchError(false);
      setSearchTerm(value);
      updateAddressSearch(value, publicId);
    },
    addressClickFromDropdown
  };

  useEffect(() => {
    const filteredBanners = cmsConfig?.banners?.filter(b => {
      const now = new Date();
      const time = now.toTimeString().split(' ')[0];
      if (!b.daysActive.includes(now.getDay())) return false;

      if ((b.fromTime !== null && b.fromTime > time) || (b.toTime !== null && b.toTime < time)) return false;
      const fromDate = new Date(b.fromDate);
      const toDate = new Date(b.toDate);
      if ((b.fromDate !== null && fromDate > now) || (b.toDate !== null && toDate < now)) return false;
      return true;
    });
    setBanners(filteredBanners);
  }, [cmsConfig]);

  return (
    <>
      {
        collectionPage ? (
          <Collection
            searchProps={searchProps}
            banners={filteredBanners?.filter(b => b.journey?.includes('Collection'))}
            backgrounds={cmsConfig?.backgroundConfig}
            showClosedSites={location?.state?.showClosedSites}
            setProspectiveRestaurant={setProspectiveRestaurant}
          />
        ) : deliveryPage ? (
          <Collection
            searchProps={searchProps}
            isDelivery
            banners={filteredBanners?.filter(b => b.journey?.includes('Delivery'))}
            backgrounds={cmsConfig?.backgroundConfig}
            showClosedSites={location?.state?.showClosedSites}
            setProspectiveRestaurant={setProspectiveRestaurant}
            isFetching={restaurantByLatLongFetching || restaurantByNameFetching}
          />
        ) : (
          config.BRAND === 'PE'
            ? (
              <OrderOnline
                searchProps={searchProps}
                banners={filteredBanners?.filter(b => b.journey?.includes('Homepage'))}
                backgrounds={cmsConfig?.backgroundConfig}
                goToDeliveryPage={goToDeliveryPage}
              />
            ) : (
              <Collection
                searchProps={searchProps}
                banners={filteredBanners?.filter(b => b.journey?.includes('Collection'))}
                backgrounds={cmsConfig?.backgroundConfig}
                showClosedSites={location?.state?.showClosedSites}
                setProspectiveRestaurant={setProspectiveRestaurant}
              />
            )
        )
      }
      <NotificationModalWrapper
        show={showNotification}
        onClose={() => setShowNotification(false)}
        notificationState={showNotification}
        inApp={inApp}
      />
      <ChangeRestaurantModalWrapper
        show={showChangeRestaurantModal}
        onClose={() => setShowChangeRestaurantModal(false)}
        onChangeRestaurant={() => handleRestaurantSelected(prospectiveRestuarant, false)}
        inApp={inApp}
      />
    </>
  );
};

export default HomeController;
